const state = {
    refresh_page_is_needed: false,
    crm_module_was_changed: false,
}

const getters = {
    refreshPageIsNeeded: state => state.refresh_page_is_needed,
    CRMModuleWasChanged: state => state.crm_module_was_changed,
}

const actions = {
    setRefreshPageIsNeeded({commit}, payload) {
        commit('SET_REFRESH_PAGE_IS_NEEDED', payload)
    },
    setCRMModuleWasChanged({commit}, payload) {
        commit('SET_CRM_MODULE_WAS_CHANGED', payload)
    },
}

const mutations = {
    SET_REFRESH_PAGE_IS_NEEDED: (state, payload) => (state.refresh_page_is_needed = payload),
    SET_CRM_MODULE_WAS_CHANGED: (state, payload) => (state.crm_module_was_changed = payload),
}

export default {state, getters, actions, mutations}
